import Service from "./service";
import {TERM_SHEET_CONFIRMED, TERM_SHEET_REJECTED} from "../helpr/constants";

class ListingService extends Service {

  constructor(unauthorized=false) {
    super("LISTING_SERVICE", unauthorized);
  }

  getParticipantInstitutions = (role, curInstitution) => {
    return this.get('/participants', {
      role: role,
      institutionCode: curInstitution
    })
  }

  patchListingApplication = (institutionCode, applicationId, activeTabIndex, listingObj) => {
    if(applicationId){
      return this.patch(`/listing/${applicationId}`, { activeTabIndex: activeTabIndex, institutionCode: institutionCode }, listingObj);
    }
    return this.patch(`/listing`, { activeTabIndex: activeTabIndex, institutionCode: institutionCode }, listingObj);
  }

  retrieveTermSheets = () => {
    return this.get(`/listing`, {
      fields: 'sortKey,securityMap,createdDate,applicationId,issuerDisplayName,applicationStatus,lastUpdatedDate,institutionCode'
    });
  }

  deleteTermSheet = applicationId => {
    return this.delete(`/listing/${applicationId}`);
  }

  retrieveTermSheetDetails = (institutionCode, applicationId) => {
    return this.get(`/listing/${applicationId}`, {
      institutionCode: institutionCode
    });
  }

  reviseSecurityOfferSize = (applicationId, securityId, amount) => {
    return this.patch(`/listing/${applicationId}/security/${securityId}/revise`, {}, {
      amount: parseFloat(amount.replaceAll(',',''))
    })
  }

  reviseSecurityAmountOutstanding = (applicationId, securityId, amount) => {
    return this.patch(`/listing/${applicationId}/security/${securityId}/revise`, {}, {
      amountOutstanding: parseFloat(amount.replaceAll(',',''))
    })
  }

  reviseAllocation = (applicationId, participantId, securityId, amount) => {
    return this.patch(`/listing/${applicationId}/participant/${participantId}/revise`, {}, {
      amount: parseFloat(amount.replaceAll(',','')),
      securityId: securityId
    })
  }

  retrieveReservations = (institutionCode, applicationId, securityId) => {
    return this.get(`/listing/${applicationId}/security/${securityId}/reservations`, {
      institutionCode: institutionCode
    });
  }

  /*
    Term Sheet Administration
   */
  confirmTermSheet = (applicationId, updatedSecurityList) => {
    return this.patch(`/listing/${applicationId}/administer`, {}, {
      applicationStatus: TERM_SHEET_CONFIRMED,
      securityList: updatedSecurityList
    });
  }

  rejectTermSheet = applicationId => {
    return this.patch(`/listing/${applicationId}/administer`, {},  {
      applicationStatus: TERM_SHEET_REJECTED
    });
  }

  extractTermSheet = (applicationId) => {
    return this.get(`/listing/${applicationId}/download`);
  }

  /*
    Document Endpoints
   */
  retrieveRequiredDocuments = (institutionCode, applicationId) => {
    return this.get(`/listing/${applicationId}/doc`, {
      institutionCode: institutionCode
    });
  }

  retrieveRequiredDocument = (applicationId, documentId, key, institutionCode) => {
    return this.get(`/listing/${applicationId}/doc/${documentId}`, {
      key: key,
      institutionCode: institutionCode
    });
  }

  approveRequiredDocument = (applicationId, documentId, key) => {
    return this.delete(`/listing/${applicationId}/doc/${documentId}`, {
      key: key,
      institutionCode: '',
      status: '0'
    });
  }

  rejectRequiredDocument = (applicationId, documentId, key, reason) => {
    return this.delete(`/listing/${applicationId}/doc/${documentId}`, {
      key: key,
      institutionCode: '',
      reason: reason,
      status: '1'
    });
  }

  deleteRequiredDocument = (applicationId, documentId, key, institutionCode) => {
    return this.delete(`/listing/${applicationId}/doc/${documentId}`, {
      key: key,
      institutionCode: institutionCode
    });
  }

  retrieveUploadPreSignedUrl = (applicationId, documentId, file, institutionCode) => {
    return this.get(`/listing/${applicationId}/doc/${documentId}/upload`, {
      key: file.name,
      type: file.type,
      institutionCode: institutionCode
    });
  }

  uploadRequiredDocument = (path, file) => {
    return this.unsignedPut(path, file, {
      headers : {
        'Content-Type' : file.type
      }
    });
  }

  listUnderwriterDesignation = () => {
    return this.get('/participants/designations');
  }
}

export default ListingService;


